module.exports = __webpack_public_path__ + "img/dola789Logo.4c643589.png";